module.exports = __webpack_public_path__ + "img/campus-recruitment.29dd5fe0.png";